import { BasePage } from "../../common/BasePage";

import { observer } from "mobx-react-lite";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { storeContext } from "../../../store/root-store";
import { MyCustomScroll } from "../../common/MyCustomScroll";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { DateButtons } from "../../../enums/DateButtons";
import { Settings } from "../../../store/Settings";
import { AdminService } from "../../../services/AdminService";
import GptScroll from "../checkPage/GptScroll";
import { usePageElements } from "../../../hooks/usePageElements";
import { Loader } from "../../common/Loader";
import { EventComp } from "../list/EventComponents/EventComp";

export const LikesPage = observer(({}) => {
  const {
    eventsStore,
    settingsGl,
    filterTagGl,
    filterDatesGl,
    adminDateFilterGl,
  } = useContext(storeContext);
  const [firstLoad, setFirstLoad] = useState<boolean>(false);
  const contWrapper = useRef<HTMLDivElement | null>(null);
  const { getHeightForScroll } = usePageElements();
  const scrollElementHeight = getHeightForScroll();

  const [hasMore, setHasMore] = useState<boolean>(false);

  const nav = useNavigate();

  const getEvents = () => {
    return async (currentPage: number = 0) => {
      return await eventsStore.getLikedEvents(
        currentPage,
        Settings.chunkLength
      );
      // return res;
    };
  };

  const onFirstLoad = async () => {
    settingsGl.currentPage = 0;
    eventsStore.listOfPreviewEvents = [];
    settingsGl.scrollElementHeight = getHeightForScroll();
    const loadResult = await getEvents()(settingsGl.currentPage);
    setHasMore(loadResult.hasMore);
  };

  useEffect(() => {
    onFirstLoad();
  }, []);

  return (
    <BasePage>
      <h3 className="base-page-element" style={{ paddingTop: 0.5 + "rem" }}>
        Избранное
        <hr />
      </h3>
      <div
        ref={contWrapper}
        // style={{ border: 1 + "px solid black" }}
      >
        <GptScroll
          hasMoreGl={hasMore}
          reload={settingsGl.scrollKeyCounter}
          // height={87 + "vh"}
          minHeight={50 + " vh"}
          height={settingsGl.scrollElementHeight - 3 + "px"}
          startPage={settingsGl.currentPage}
          onScroll={getEvents()}
          // onScroll={testEvents()()}
          onFirstLoadFinish={(firstLoad) => {
            setFirstLoad(firstLoad);
          }}
        >
          <>
            {!eventsStore.isEventsLoaded && <Loader></Loader>}
            {eventsStore.isEventsLoaded &&
              eventsStore.listOfPreviewEvents.length == 0 && (
                <div className="d-flex">
                  Вы пока не добавили события в избранное!
                </div>
              )}
            <div className="row">
              {eventsStore.listOfPreviewEvents.map((el, index, ar) => {
                return (
                  <div key={el.id} className="col-md-6 col-12 col-sm-12 mt-2">
                    <EventComp
                      onClick={() => {}}
                      key={el.id}
                      event={el}
                      // className="col-6 col-sm-6 mt-2"
                      className=""
                    />
                    {/* {index == ar.length - 1 && (
                    <div
                      key={el.id}
                      className="mobile-nav-margin col-12 col-sm-12 mt-2"
                    ></div>
                  )} */}
                  </div>
                );
              })}
              {/* {!settingsGl.selectedTag.id && firstLoad && (
              <EmptyPlaceholder selectedTag={settingsGl.selectedTag} />
            )} */}
            </div>
          </>
        </GptScroll>
      </div>
    </BasePage>
  );
});
